import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Icon from 'components/common/Icon/Icon'
import Mixin from 'components/common/Mixin'
import SERVICE_TYPES from './constants'

const ServiceIcon = ({
  iconName,
  condition,
  width,
  height,
  grey = false,
  ...props
}) =>
  <ServiceIconWrapper
    asset={ grey ? SERVICE_TYPES[iconName].asset : SERVICE_TYPES[iconName].alternative }
    alternative={ grey ? SERVICE_TYPES[iconName].asset : SERVICE_TYPES[iconName].alternative }
    alt=""
    condition={ condition }
    width={ width }
    height={ height }
    { ...props } />

ServiceIcon.propTypes = {
  condition: PropTypes.bool,
  grey: PropTypes.bool,
  height: PropTypes.number,
  iconName: PropTypes.string,
  width: PropTypes.number
}

export default ServiceIcon

const ServiceIconWrapper = styled(Icon)`
  ${Mixin.responsive('width', '95px', '30px')}
  ${Mixin.responsive('height', '95px', '30px')}
  ${props => props.larger && css`
    ${Mixin.responsive('width', '144px', '60px')}
    ${Mixin.responsive('height', '144px', '60px')}
  `}
  ${props => props.large && css`
    ${Mixin.responsive('width', '128px', '56px')}
    ${Mixin.responsive('height', '128px', '56px')}
  `}
  ${props => props.small && css`
    width: 56px;
    height: 56px;
  `}
  ${props => props.full && css`
    ${Mixin.responsive('width', '100%', '100%')}
    ${Mixin.responsive('height', '100%', '100%')}
  `}
  ${props => props.width && css`
    && {
      width: ${props.width}px;
    }
  `}
  ${props => props.height && css`
    && {
      height: ${props.height}px;
    }
  `}
`
